import React from "react";

/**
 * Decorative branch/leaf line-art used to break up flat sections.
 * variant: "corner" | "divider" | "sprig"
 */
export default function Ornament({ variant = "divider", className = "" }) {
  if (variant === "corner") {
    return (
      <svg
        className={className}
        width="120"
        height="120"
        viewBox="0 0 120 120"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4 4C40 4 70 8 88 26C106 44 116 72 116 108"
          stroke="url(#ornGrad)"
          strokeWidth="1"
        />
        <path
          d="M40 10c8 6 10 16 6 24"
          stroke="url(#ornGrad)"
          strokeWidth="1"
        />
        <path
          d="M70 20c10 2 18 10 18 20"
          stroke="url(#ornGrad)"
          strokeWidth="1"
        />
        <circle cx="4" cy="4" r="2.5" fill="#C9A667" />
        <defs>
          <linearGradient id="ornGrad" x1="0" y1="0" x2="120" y2="120">
            <stop offset="0%" stopColor="#C9A667" stopOpacity="0.9" />
            <stop offset="100%" stopColor="#C9A667" stopOpacity="0" />
          </linearGradient>
        </defs>
      </svg>
    );
  }

  if (variant === "sprig") {
    return (
      <svg
        className={className}
        width="60"
        height="140"
        viewBox="0 0 60 140"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M30 140V10"
          stroke="#C9A667"
          strokeOpacity="0.5"
          strokeWidth="1"
        />
        <path
          d="M30 30c0-12 14-18 20-14-2 10-10 16-20 14Z"
          fill="#C9A667"
          fillOpacity="0.15"
          stroke="#C9A667"
          strokeOpacity="0.6"
          strokeWidth="1"
        />
        <path
          d="M30 55c0-12-14-18-20-14 2 10 10 16 20 14Z"
          fill="#C9A667"
          fillOpacity="0.15"
          stroke="#C9A667"
          strokeOpacity="0.6"
          strokeWidth="1"
        />
        <path
          d="M30 80c0-12 14-18 20-14-2 10-10 16-20 14Z"
          fill="#C9A667"
          fillOpacity="0.15"
          stroke="#C9A667"
          strokeOpacity="0.6"
          strokeWidth="1"
        />
        <circle cx="30" cy="10" r="3" fill="#C9A667" />
      </svg>
    );
  }

  // divider
  return (
    <svg
      className={className}
      width="160"
      height="24"
      viewBox="0 0 160 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 12H60" stroke="#C9A667" strokeOpacity="0.5" strokeWidth="1" />
      <path
        d="M100 12H160"
        stroke="#C9A667"
        strokeOpacity="0.5"
        strokeWidth="1"
      />
      <circle cx="80" cy="12" r="3" fill="#C9A667" />
      <path
        d="M70 12c2-6 8-9 12-6"
        stroke="#C9A667"
        strokeOpacity="0.6"
        strokeWidth="1"
      />
      <path
        d="M90 12c-2-6-8-9-12-6"
        stroke="#C9A667"
        strokeOpacity="0.6"
        strokeWidth="1"
      />
    </svg>
  );
}
